import React from 'react'
import { useDispatch } from 'react-redux'
import { openModalWindow } from '../../../../store/ModalWindowData/action'
import useTranslate from '../../../../hooks/useTranslate'

const SymptomSurveyButton: React.FC = (): JSX.Element => {
  const dispatch = useDispatch()
  const t = useTranslate()

  const handleClick = () => {
    dispatch(openModalWindow('symptomSurvey', {}))
  }

  return (
    <button
      type="button"
      className="g_btn g_btn--primary create-patient-btn"
      onClick={handleClick}
    >
      <span>{t('start-page.button.symptom-survey')}</span>
    </button>
  )
}

export default SymptomSurveyButton
